<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div id="row1" class="row">
            <div class="col col-12">
                <h1>request dashboard by status</h1>
                <by-request-status [allowRequestStatusChange]="true" [showDetails]="true"
                    [numberOfMonths]="numberOfMonths" [requestStatus]="initialRequestStatus">
                </by-request-status>
            </div>
        </div>
    </section>
</main>